module.exports = __webpack_public_path__ + "ecc5f3c5184bec0ca03801f4abc58dde.jpg";